<mat-paginator
  [length]="totalResult"
  [disabled]="!displayPager"
  [pageSizeOptions]="pageSizeOptionData"
  [ngClass]="{
    'display-pager': displayPager,
    'paginator-hide': totalResult <= defaultPageSize
  }"
  class="mat-paginator-sticky display-pager"
  [pageSize]="defaultPageSize"
  [hidePageSize]="hidePageSizer || totalResult < defaultPageSize"
  (page)="handlePage($event)"
></mat-paginator>
<span
  *ngIf="totalResult"
  class="total-active-test"
  [ngClass]="{ 'paginator-hide': totalResult <= defaultPageSize, result: totalResVisible }"
  >Total : {{ totalCount ? totalCount : totalResult }}</span
>
